import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Information from './../Information';
import xlsx from "xlsx";
import BookingService from './../../../services/cargobooking.service';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Papa from "papaparse";
import Multiselect from 'vue-multiselect';
import moment from 'moment';


export default {
  name: 'Createbookingtype',
  components: {
    VueElementLoading,
    Information,
    Treeselect,
    Multiselect
  },
  props: ['Clientlist'],
  data: function() {
    return {
      isLoading: false,
      filename:"",
      client :null,
      businessaccountname:'',
      clientbusinessdetailid:'',
      clientbusinessaccountid:'',
      SKUData:[],
      SKUlist:[],
      ClientUOM:"",
      activecontract: "",
      totalRecords:0,
      successRecords:0,
      failedRecords:{},
      showresult:false,
      disabled: false,
      FailedResultModal: false,
      disableclientselection: false,
      compNameArr:[],
      uomArr:[],
      manifestMethods: [],
      boxtypelist: [],
      clientFileType:null,
      filesource:"",
      showuploadresult: false,
      uploadResultData:[],
      importResultData:[],
      showimportbutton:false,
      showdownloadbutton:false,
      showimportresult:false,
      batchsizeforimport:0,
      bookingDataArr:[],
      vaidData:[],
      flipkartUpload: false,
      flipkartprogress: false,
      flipkartprogressarr: ['stop','stop', 'stop', 'stop', 'stop'],
      showSpinner: false,
      flipkartDataValiated:0,
      flipkartTotalRecord:0,
      validFCPO:[],
      FCfaileddata:[],
      GenericFilefaileddata:[],
      FCvalidimportcount:0,
      FCResumeValidation:false,
      totalPackage:0,
      validrecordsforimport: 0,
      importdone:0,
      logfileid:null,
      showtmplflag:0
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
  },
  methods: {
    async selectClient(data){
      this.resetform();
      if(data){
        this.activecontract = data.ContractId;
        this.businessaccountname = data.CompanyName;
        this.clientbusinessdetailid = data.ClientBusinessDetailId;
        this.clientbusinessaccountid = data.ClientBusinessAccountId;
        this.disableclientselection = true;
        this.isLoading = true;
        await Promise.all([
        // this.getSKUList(data.id, data.ClientBusinessAccountId),
        this.getClientUOM(data.ClientId, data.ClientBusinessAccountId),
        this.getClientFileType(data.ClientId, data.ClientBusinessAccountId),
        ])
        this.isLoading = false;
        if (this.clientFileType == 0) {
          this.filesource = "../static/SampleFileWithoutSeller.csv";
        }else if(this.clientFileType == 1){
          this.filesource = "../static/SampleFileWithSeller.csv";
        }else if(this.clientFileType == 2){
          this.filesource = "../static/Reliance-format.csv";
        }else if(this.clientFileType == 3){
          this.filesource = "../static/TMPL-format.csv";
        }else{
          this.filesource = "../static/Sample_Booking_Data.xlsx";
        }
      }
    },
    async getClientUOM(clientid, clientbusinessaccountid){
      try {
        let InputPayload = {
          clientid: clientid,
          clientbusinessaccountid: clientbusinessaccountid
        }
        let result = await ClientService.getClientUOM(InputPayload);
        this.ClientUOM = result.data.data.uom;
        this.manifestMethods = result.data.data.manifestdatauploadmethod;
      } catch(err){
        console.log(err);
      }
    },
    async getClientFileType(clientid, clientbusinessaccountid){
      try {
        let InputPayload = {
          clientid: clientid,
          clientbusinessaccountid: clientbusinessaccountid
        }
        let result = await BookingService.getClientFileType(InputPayload);
        this.clientFileType = (result.data.data.clientfiletype==2)?3:result.data.data.clientfiletype;
        this.batchsizeforimport = result.data.data.batchsizeforimport;
      } catch(err){
        console.log(err);
      }
    },
    async getSKUList(clientid, clientbusinessaccountid) {
     try {
       this.isLoading = true;
        if(clientid){
          this.clientid = clientid;
        }
        this.SKUData = [];
        this.SKUlist = [];
        this.boxtypelist = [];
        let InputPayload = {
          clientid: clientid,
          clientbusinessaccountid: clientbusinessaccountid
        }
        let result = await ClientService.getClientSKUList(InputPayload);
        let skudata = result.data.data;
        let boxtype = []
        boxtype = this.groupBy(skudata, "boxtype");
        for (var key in boxtype) {
          this.boxtypelist.push(boxtype[key][0].boxtype);
        }
        this.SKUData = this.groupBy(skudata, "productcategory");
        for (var key in this.SKUData) {
          this.SKUlist.push(this.SKUData[key][0].productcategory);
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    async uploadBookingData(e){
     this.filename = "";
     this.isLoading = true;
     const files = e.target.files;
     if (!files.length) {
       this.isLoading = false;
       this.$refs.files.value=null;
       return ;
     } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase()) && this.clientFileType == 4) {
       this.isLoading = false;
       this.$refs.files.value=null;
       return this.$alert('The upload format is incorrect. Please download template for correct format', "", "error");
     }else if (!/\.(csv|CSV)$/.test(files[0].name.toLowerCase()) && this.clientFileType != 4) {
       this.isLoading = false;
       this.$refs.files.value=null;
       return this.$alert('The upload format is incorrect. Please download template for correct format', "", "error");
     }

     this.filename = e.target.files[0].name;
     this.file = e.target.files[0];
     const fileReader = new FileReader();
     if (this.clientFileType == 4) {
       this.isLoading = true;
       fileReader.onload = async ev => {
         try {
           const data = ev.target.result;
           const XLSX = xlsx;
           const workbook = XLSX.read(data, {
             type: "binary"
           });
           const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
           const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {raw:true, header: 3 }); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
           let compNameArr = [];
           let uomArr = [];
           for (var i = 2; i < ws.length; i++) {
             if(ws[i].__EMPTY_2){
               compNameArr.push(ws[i].__EMPTY_2);
             }
             if(ws[i].__EMPTY_23){
               uomArr.push(ws[i].__EMPTY_23);
             }
           }
           this.compNameArr = [ ...new Set(compNameArr) ];
           this.uomArr = [ ...new Set(uomArr) ];
           if(!this.manifestMethods.includes("SoftDataUpload")){
             this.$alert("Soft Data Upload method was not configured for client "+this.client.label, "", "error");
           }else if(this.compNameArr.length>1){
             this.$alert("Multiple Client’s Name Exists", "", "error");
           }else if(this.compNameArr.length==1 && this.compNameArr[0]!=this.client.label){
             this.$alert("Client Display Name Not Matched with Selected Client", "", "error");
           }else if(this.uomArr.length>1){
             this.$alert("Multiple Box Dimension UOM Exists", "", "error");
         }else if (this.uomArr.length==1 && this.uomArr[0]!='cm' && this.uomArr[0]!='in'){
             this.$alert("Box Dimension UOM Should be 'in' or 'cm'", "", "error");
           }else{
             await this.validateXLSXdata(this.file);
             this.isLoading = false;
             this.showimportbutton = false;
           }
         } catch (e) {
           this.$refs.files.value=null;
           this.isLoading = false;
           return this.$alert('Read failure!', "", "error");
         }
       };
       fileReader.readAsBinaryString(files[0]);
     } else if (this.clientFileType == 3) {
       //TMPL file validation
       this.isLoading = true;
       this.flipkartprogress = true;
       this.validFCPO=[];
       this.$set(this.flipkartprogressarr, 0 , 'start');
       try {
         let jsonData = [];
         let headers = [];
         let rows = [];
         const parseFile = rawFile => {
           return new Promise(resolve => {
             Papa.parse(rawFile, {
               complete: results => {
                 resolve(results.data);
               }
             });
           });
         };
         rows = await parseFile(e.target.files[0]);
         for (let i = 0; i < rows.length; i++) {
           let cells = rows[i];
           let rowData = {};
           if (cells.length > 1) {
             for (let j = 0; j < cells.length; j++) {
               if (i == 0) {
                 let headerName = cells[j].trim();
                 headers.push(headerName);
               } else {
                 let key = headers[j];
                 if (key) {
                   rowData[key] = cells[j].trim();
                 }
               }
             }
             //skip the first row (header) data
             if (i != 0) {
               jsonData.push(rowData);
             }
           }
         }
         await this.validatetmpldata(jsonData);
         this.showimportbutton = false;
         this.$set(this.flipkartprogressarr, 0, 'complete');
       } catch (error) {
           this.$refs.files.value=null;
           this.isLoading = false;
           return this.$alert('Read failure!', "", "error");
       }
       fileReader.readAsBinaryString(files[0]);
       this.isLoading = false;
     } else if (this.clientFileType == 0 || this.clientFileType == 1) {
      this.flipkartprogress = true;
      this.$set(this.flipkartprogressarr, 0 , 'start')
      try {
        let jsonData = [];
        let headers = [];
        let rows = [];
        const parseFile = rawFile => {
          return new Promise(resolve => {
            Papa.parse(rawFile, {
              complete: results => {
                resolve(results.data);
              }
            });
          });
        };

        rows = await parseFile(e.target.files[0]);
        for (let i = 0; i < rows.length; i++) {
          let cells = rows[i];
          let rowData = {};
          if (cells.length > 1) {
            for (let j = 0; j < cells.length; j++) {
              if (i == 0) {
                let headerName = cells[j].trim();
                headers.push(headerName);
              } else {
                let key = headers[j];
                if (key) {
                  rowData[key] = cells[j].trim();
                }
              }
            }
            //skip the first row (header) data
            if (i != 0) {
              jsonData.push(rowData);
            }
          }
        }
        await this.validateflikartdata(jsonData);
        this.showimportbutton = false;
        if (this.totalPackage > 20000) {
          this.$alert('Total no of Package exceeded 20000.', "", "error");
          this.$set(this.flipkartprogressarr, 0, 'stop');
          this.isLoading = false;
          this.resetform();
        } else {
          this.$set(this.flipkartprogressarr, 0, 'complete')
        }
      } catch (error) {
          this.$refs.files.value=null;
          this.isLoading = false;
          return this.$alert('Read failure!', "", "error");
      }
      fileReader.readAsBinaryString(files[0]);
     }
     this.isLoading = false;
   },
   submitFile(){
    if ((this.clientFileType == 0 || this.clientFileType == 1 || this.clientFileType == 3) && this.validFCPO.length == 0) {

    } else {
      this.flipkartUpload = false;
      this.showresult= false;
      this.successRecords=0;
      this.validrecordsforimport=0;
      this.failedRecords = {};
      this.failRecordCount = 0;
    }
     this.$validator.validateAll("uploadform").then((result) => {
       if (result) {
       if(result && (this.clientFileType == 0 || this.clientFileType == 1)) {
        if (this.validFCPO.length > 0) {
          this.$set(this.flipkartprogressarr, 1 , 'start')
           this.startFlipkartFileUpload();
        }
       }else if(result && this.clientFileType == 2){
         this.startB2BMarketplaceFileUpload();
       }else if(result && this.clientFileType == 3){
         if (this.validFCPO.length > 0) {
           this.$set(this.flipkartprogressarr, 1 , 'start');
           this.startFTPLFileUpload();
         }
       }else{
         if (this.validFCPO.length > 0) {
           this.$set(this.flipkartprogressarr, 1 , 'start')
            this.startUpload();
         }
       }
     }}).catch(() => {
       console.log('errors exist');
       return false;
     });
   },
   async startUpload(){
     try {
       this.disabled = true;
       this.isLoading = true;
       let formData = new FormData();
       formData.append('importdata', JSON.stringify(this.validFCPO));
       formData.append('file', this.file);
       formData.append('lastmodifiedby', this.userName);
       let result = await BookingService.uploadBookingData(formData);
       this.isLoading = false;
       if (result.data.code == 200) {
         this.$set(this.flipkartprogressarr, 1 , 'complete');
         this.$set(this.flipkartprogressarr, 2 , 'start');
         this.$alert(result.data.message, "", "success");
         this.logfileid = result.data.data.logfileid;
         this.flipkartTotalRecord = result.data.data.totalrecord;
         await this.ValidateGenericClientData(this.flipkartTotalRecord);
         this.$set(this.flipkartprogressarr, 2 , 'complete');
         this.showresult = true;
       }else{
         this.$alert(result.data.message, "", "error");
       }
     } catch(err){
       this.isLoading = false;
       this.$alert(err, "", "error");
       console.log(err);
     }
   },
   async startFlipkartFileUpload(){
     try {
       this.disabled = true;
       this.isLoading = true;
       let formData = new FormData();
       this.scrollToProgress()
       formData.append('clientfiletype', this.clientFileType);
       formData.append('clientid', this.client.ClientId);
       formData.append('clientname', this.client.label);
       formData.append('businessaccountname', this.businessaccountname);
       formData.append('clientbusinessdetailid', this.clientbusinessdetailid);
       formData.append('clientbusinessaccountid', this.clientbusinessaccountid);
       formData.append('file', this.file);
       formData.append('lastmodifiedby', this.userName);
       formData.append('polist', this.validFCPO);
       this.showSpinner = true;
       let result = await BookingService.FlipkartUpload(formData);
       this.isLoading = false;
       if (result.data.code == 200) {
        this.$set(this.flipkartprogressarr, 1 , 'complete')
        this.$set(this.flipkartprogressarr, 2 , 'start')
        this.logfileid = result.data.data.logfileid;
         this.flipkartTotalRecord = result.data.data.totalrecord;
         this.$alert(result.data.message, "", "success");
         await this.validateflikartUploadeddata(this.flipkartTotalRecord)
        this.$set(this.flipkartprogressarr, 2 , 'complete')
         this.showresult = true;
       }else{
         this.$alert(result.data.message, "", "error");
       }
     } catch(err){
       this.isLoading = false;
       this.$alert(err, "", "error");
       console.log(err);
     }
   },
   async startB2BMarketplaceFileUpload(){
     try {
       this.disabled = true;
       this.isLoading = true;
       let formData = new FormData();
       formData.append('clientfiletype', this.clientFileType);
       formData.append('clientid', this.client.ClientId);
       formData.append('clientname', this.client.label);
       formData.append('businessaccountname', this.businessaccountname);
       formData.append('clientbusinessdetailid', this.clientbusinessdetailid);
       formData.append('clientbusinessaccountid', this.clientbusinessaccountid);
       formData.append('file', this.file);
       formData.append('lastmodifiedby', this.userName);
       let result = await BookingService.B2BMarketplaceUpload(formData);
       this.isLoading = false;
       if (result.data.code == 200) {
         this.$alert(result.data.message, "", "success");
         let uploadata = result.data.data;
         this.logfileid = uploadata[0].logfileid;
         this.totalRecords = uploadata.length;
         let logcount = this.groupBy(uploadata, "isvalid");
         if(logcount[1]){
           this.successRecords = logcount[1];
         }
         if(logcount[0]){
           this.failedRecords = logcount[0];
         }
         this.showresult = true;
       }else{
         this.$alert(result.data.message, "", "error");
       }
     } catch(err){
       this.isLoading = false;
       this.$alert(err, "", "error");
       console.log(err);
     }
   },
   async startFTPLFileUpload(){
     try {
       this.showtmplflag = 0;
       this.disabled = true;
       this.isLoading = true;
       let formData = new FormData();
       this.scrollToProgress();
       formData.append('clientid', this.client.ClientId);
       formData.append('clientname', this.client.label);
       formData.append('businessaccountname', this.businessaccountname);
       formData.append('clientbusinessdetailid', this.clientbusinessdetailid);
       formData.append('clientbusinessaccountid', this.clientbusinessaccountid);
       formData.append('file', this.file);
       formData.append('lastmodifiedby', this.userName);
       this.showSpinner = true;
       let result = await BookingService.TMPLUpload(formData);
       this.isLoading = false;
       if (result.data.code == 200) {
        this.$set(this.flipkartprogressarr, 1 , 'complete')
        this.$set(this.flipkartprogressarr, 2 , 'start')
        this.logfileid = result.data.data.logfileid;
         this.flipkartTotalRecord = result.data.data.totalrecord;
         this.$alert(result.data.message, "", "success");
         await this.validatetmplUploadeddata(this.flipkartTotalRecord)
        this.$set(this.flipkartprogressarr, 2 , 'complete')
         this.showresult = true;
       }else{
         this.$alert(result.data.message, "", "error");
       }
     } catch(err){
       this.isLoading = false;
       this.$alert(err, "", "error");
       console.log(err);
     }
   },
   resetform(){
     this.file = "";
     this.client = null;
     this.logfileid = null;
     this.activecontract = '';
     this.toalRecords = 0;
     this.successRecords = 0;
     this.failedRecords = {};
     this.manifestMethods = [];
     this.$refs.files.value=null;
     this.filename = '';
     this.disabled = false;
     this.showresult = false;
     this.disableclientselection = false;
     this.filesource = "";
     this.clientFileType = null;
     this.showuploadresult = false;
     this.uploadResultData = null;
     this.showimportbutton=false;
     this.showimportresult=false;
     this.$validator.reset();
     this.flipkartUpload = false;
     this.failRecordCount = 0;
     this.flipkartprogressarr = ['stop', 'stop', 'stop', 'stop', 'stop'];
     this.showSpinner = false;
     this.flipkartDataValiated = 0;
     this.flipkartTotalRecord = 0;
     this.flipkartprogress = false;
     this.validFCPO=[];
     this.FCfaileddata=[];
     this.GenericFilefaileddata=[];
     this.FCvalidimportcount=0;
     this.totalPackage = 0;
     this.importdone = 0;
   },
   showBookingType() {
      this.$emit("goBackToParent");
    },
    openFailedResultModal(){
      this.FailedResultModal = true;
    },
    closeFailedResultModal(){
      this.FailedResultModal = false;
    },
    openUploadResultData(type){
      this.showtmplflag = 1;
      this.showuploadresult = true;
      this.uploadResultData = null;
      this.showimportbutton=false;
      if(type=='valid'){
        this.showdownloadbutton = false;
        this.uploadResultData = this.successRecords;
        this.showimportresult = false;
        if(this.successRecords.length>0 || this.importResultData.length!=this.successRecords.length){
          if(this.clientFileType==2){
            this.showimportbutton=true;
          }else if(this.logfileid){
            this.showimportbutton=true;
          }
        }
      }else if(type=='invalid'){
        this.showdownloadbutton = true;
        this.showimportresult = false;
        this.showimportbutton=false;
        this.uploadResultData = this.failedRecords;
      }
    },
    async importValidRecords(){
      try {
        this.isLoading = true;
        let inputPayload = {
          fileid: this.logfileid,
          lastmodifiedby: this.userName
        }
        let loop = Math.ceil(this.validrecordsforimport / this.batchsizeforimport)
        this.showuploadresult = false;
        this.showimportresult = true;
        this.totalRecords = 0;
        this.successRecords = {};
        this.failedRecords = {};
        let uploadata = [];
        let result;
        if(this.clientFileType == 4){
          this.isLoading= false;
          this.FCResumeValidation=false;
          this.showresult = false;
          this.showSpinner= true
          this.$set(this.flipkartprogressarr, 3 , 'start')
          this.scrollToProgress();
          for (let i = 0; i < loop ; i++) {
             inputPayload.limit = this.batchsizeforimport;
             result = await BookingService.PushExcelValidRecords(inputPayload);
             if (result.data.code != 200 && i <= loop-1) {
               this.FCResumeValidation = true;
              } else {
               this.FCResumeValidation = false;
                result.data.data.forEach(element => {
                  uploadata.push(element)
                  this.FCvalidimportcount = this.FCvalidimportcount + 1;
                 });
              }

             if ((result.data.code == 200 && i == loop-1) || (result.data.code == 103)) {
               let input = {
                 fileid: this.logfileid
               }
               let uploadresult = await BookingService.getGenericUploadData(input);
               if (uploadresult.data.code == 200) {
                 uploadata= uploadresult.data.data;
               }
              this.FCResumeValidation = false;

              this.$alert(result.data.message, "", "success");
              this.logfileid = uploadata[0].logfileid;
              this.totalRecords = uploadata.length;
              let logcount = this.groupBy(uploadata, "status");
              let pushlogcount = this.groupBy(uploadata, "pushstatus");
              this.$set(this.flipkartprogressarr,  3, 'complete');
              this.$set(this.flipkartprogressarr,  4, 'complete');
              this.importResultData = pushlogcount[1].sort(((a,b) => a.batchid - b.batchid));
              if(logcount[1]){
                this.successRecords = logcount[1].sort(((a,b) => a.batchid - b.batchid));
              }
              if(logcount[0]){
                this.failedRecords = logcount[0].sort(((a,b) => a.batchid - b.batchid));
              }
              this.showSpinner = false;
              this.isLoading = false;
              this.showresult = true;
              this.showimportbutton = false;
              if (result.data.code == 103) {
                break;
              }
            }else if(i == loop - 1){
              this.isLoading = false;
              this.$alert(result.data.message, "", "error");
            }
          }
        }else if(this.clientFileType == 2 ){
          let result = await BookingService.PushB2BMarketplaceValidRecords(inputPayload);
          if (result.data.code == 200) {
            this.$alert(result.data.message, "", "success");
            uploadata = result.data.data;
            this.logfileid = uploadata[0].logfileid;
            this.totalRecords = uploadata.length;
            let logcount = this.groupBy(uploadata, "isvalid");
            let pushlogcount = this.groupBy(uploadata, "pushstatus");
            this.importResultData = pushlogcount[1];
            if(logcount[1]){
              this.successRecords = logcount[1];
            }
            if(logcount[0]){
              this.failedRecords = logcount[0];
            }
            this.isLoading = false;
            this.showresult = true;
          }else{
            this.$alert(result.data.message, "", "error");
          }
        }else if(this.clientFileType == 3 ){
          this.isLoading= false;
          this.FCResumeValidation=false;
          this.showresult = false;
          this.showSpinner= true
          this.$set(this.flipkartprogressarr, 3 , 'start')
          this.scrollToProgress();
          for (let i = 0; i < loop; i++) {
            inputPayload.limit = this.batchsizeforimport;
            let result = await BookingService.PushTMPLValidRecords(inputPayload);
            if (result.data.code != 200 && i <= loop-1) {
              this.FCResumeValidation = true;
             } else {
              this.FCResumeValidation = false;
               result.data.data.forEach(element => {
                 uploadata.push(element)
                 this.FCvalidimportcount = this.FCvalidimportcount + 1;
                });
             }
            if ((result.data.code == 200 && i == loop-1) || (result.data.code == 103)) {
              let input = {
                fileid: this.logfileid
              }
              let uploadresult = await BookingService.getGenericUploadData(input)
              if (uploadresult.data.code == 200) {
                let jsonArray = uploadresult.data.data;
                jsonArray.forEach(obj => {
                    // Rename the attribute
                    obj.consignor = obj.pickuplocationname;
                    obj.pincode = obj.destinationpincode;
                    obj.consignee = obj.consingneecode +' - '+ obj.consingneename;
                    delete obj.pickuplocationname;
                    delete obj.destinationpincode;
                    delete obj.consingneecode;
                });
                uploadata = jsonArray;
              }
              this.FCResumeValidation = false;
              this.$alert(result.data.message, "", "success");
              // let uploadata = result.data.data;
              this.logfileid = uploadata[0].logfileid;
              this.FCvalidimportcount = uploadata.length
              this.totalRecords = uploadata.length;
              let logcount = this.groupBy(uploadata, "status");
              let pushlogcount = this.groupBy(uploadata, "pushstatus");
              this.$set(this.flipkartprogressarr,  3, 'complete');
              this.$set(this.flipkartprogressarr,  4, 'complete');
              this.importResultData = pushlogcount[1].sort(((a,b) => a.awbnumber - b.awbnumber));
              if(logcount[1]){
                this.successRecords = logcount[1].sort(((a,b) => a.awbnumber - b.awbnumber));
              }
              if(logcount[0]){
                this.failedRecords = logcount[0].sort(((a,b) => a.awbnumber - b.awbnumber));
              }
              this.showSpinner = false;
              this.isLoading = false;
              this.showresult = true;
              if (result.data.code == 103) {
                break;
              }
            }else if (i == loop-1){
              this.isLoading = false;
              this.$alert(result.data.message, "", "error");
            }
          }
        }else{
          try {
            this.isLoading= false;
            this.FCResumeValidation=false;
            this.showresult = false;
            this.showSpinner= true
            this.$set(this.flipkartprogressarr, 3 , 'start')
            this.scrollToProgress();
            for (let i = 0; i < loop; i++) {
              inputPayload.limit = this.batchsizeforimport;
              let result = await BookingService.PushFlipkartValidRecords(inputPayload);
              if (result.data.code != 200 && i <= loop-1) {
                this.FCResumeValidation = true;
               } else {
                this.FCResumeValidation = false;
                 result.data.data.forEach(element => {
                   uploadata.push(element)
                   this.FCvalidimportcount = this.FCvalidimportcount + 1;
                  });
               }
              if ((result.data.code == 200 && i == loop-1) || (result.data.code == 103)) {
                let input = {
                  fileid: this.logfileid
                }
                let uploadresult = await BookingService.getFCuploaddata(input)
                if (uploadresult.data.code == 200) {
                  uploadata= uploadresult.data.data;
                }
                this.FCResumeValidation = false;
                this.$alert(result.data.message, "", "success");
                // let uploadata = result.data.data;
                this.logfileid = uploadata[0].logfileid;
                this.FCvalidimportcount = uploadata.length
                this.totalRecords = uploadata.length;
                let logcount = this.groupBy(uploadata, "isvalid");
                let pushlogcount = this.groupBy(uploadata, "pushstatus");
                this.$set(this.flipkartprogressarr,  3, 'complete');
                this.$set(this.flipkartprogressarr,  4, 'complete');
                this.importResultData = pushlogcount[1].sort(((a,b) => a.batchid - b.batchid));
                if(logcount[1]){
                  this.successRecords = logcount[1].sort(((a,b) => a.batchid - b.batchid));
                }
                if(logcount[0]){
                  this.failedRecords = logcount[0].sort(((a,b) => a.batchid - b.batchid));
                }
                this.showSpinner = false;
                this.isLoading = false;
                this.showresult = true;
                if (result.data.code == 103) {
                  break;
                }
              }else if (i == loop-1){
                this.isLoading = false;
                this.$alert(result.data.message, "", "error");
              }
            }
          } catch (error) {
            this.isLoading = false;
            this.$alert("Something went wrong. To resume, Click Resume import.", "", "error");
            this.$set(this.flipkartprogressarr,  3, 'stop');
            this.FCResumeValidation = true;
            console.log(error);
          }
        }
        this.importdone = 1;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    async downloadFile() {
      let downloadArr = [];
      if(this.uploadResultData){
        if(this.clientFileType == 0 || this.clientFileType == 1){
          downloadArr = this.uploadResultData.map((el)=>{
            return {
            "Seller Name" : el.sellername,
            "Category" :  el.category,
            "Pickup Pincode" : el.sellerpincode,
            "Pickup Date" : el.pickupdate,
            "Number of packages" : el.noofpackages,
            "PO Number" : el.ponumber,
            "Message" :   el.comment,
            }
          });
        }else if(this.clientFileType == 2){
          downloadArr = this.uploadResultData.map((el)=>{
            return {
            "ASN" : (el.asn)?el.asn:null,
            "Vendor Code" : (el.vendorcode)?el.vendorcode:null,
            "Vendor Name" : (el.vendorname)?el.vendorname:null,
            "Number of packages" : (el.noofpackages)?el.noofpackages:null,
            "DC sit" : (el.dcsit)?el.dcsit:null,
            "Message" :   (el.comment)?el.comment:null
            }
          });
        }else if(this.clientFileType == 3){
          downloadArr = this.uploadResultData.map((el)=>{
            return {
            "Consignor" :  el.consignor,
            "Pickup Pincode" : el.pickuppincode,
            "Consignee" : el.consignee,
            "Destination Pincode" : el.pincode,
            "Number of packages" : el.numberofmps,
            "Message" :   el.comment,
            }
          });
        }else{
          downloadArr = this.uploadResultData.map((el)=>{
            return {
            "Batch ID" : el.batchid,
            "Client Name" :  el.clientname,
            "Pickup City" : el.pickupcity,
            "Destination City" : el.consingneecity,
            "Number of packages" : el.numberofmps,
            "Number of invoices" : el.numberofinvoices,
            "Message" :   el.comment,
            }
          });
        }
        var blob = new Blob([Papa.unparse(downloadArr)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'InvalidRecords.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }else{
        const data = xlsx.utils.json_to_sheet(downloadArr);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, 'data')
        xlsx.writeFile(wb,'InvalidRecords.xlsx');
      }
    },
    async validateXLSXdata(){
      this.flipkartprogress = true;
      this.validFCPO=[];
      this.$set(this.flipkartprogressarr, 0 , 'start');
      let formData = new FormData();
      formData.append('clientid', this.client.ClientId);
      formData.append('clientname', this.client.label);
      formData.append('businessaccountname', this.businessaccountname);
      formData.append('clientbusinessdetailid', this.clientbusinessdetailid);
      formData.append('clientbusinessaccountid', this.clientbusinessaccountid);
      formData.append('activecontract', this.activecontract);
      formData.append('file', this.file);
      let result = await BookingService.validateXLSXdata(formData);
      this.$set(this.flipkartprogressarr, 0, 'complete');
      if(result.data.code==200){
        this.showresult = true
        let fileData = result.data.data;
        this.totalRecords = result.data.data.length;
        let logcount = this.groupBy(fileData, "valid");
         if(logcount[1]){
           this.successRecords = logcount[1].sort(((a,b) => a.batchid - b.batchid));
           this.validFCPO = logcount[1].sort(((a,b) => a.batchid - b.batchid));
         }
         if(logcount[0]){
           this.failedRecords = logcount[0].sort(((a,b) => a.batchid - b.batchid));
           this.GenericFilefaileddata = logcount[0].sort(((a,b) => a.batchid - b.batchid));
         }
         if (this.validFCPO.length == 0) {
           this.disabled = true;
         }
      }
    },
    async validateflikartdata(bookingData) {
      try {
        let validHeader = bookingData[0];
        if (!validHeader.hasOwnProperty("Seller Name") || !validHeader.hasOwnProperty("Seller Email id") ||
          !validHeader.hasOwnProperty("Category") || !validHeader.hasOwnProperty("Number of packages") ||
          !validHeader.hasOwnProperty("Volume Details") || !validHeader.hasOwnProperty("PO Numbers") ||
          !validHeader.hasOwnProperty("Invoice value") || !validHeader.hasOwnProperty("Qty") ||
          !validHeader.hasOwnProperty("Pickup date") || !validHeader.hasOwnProperty("Pickup Slot") ||
          !validHeader.hasOwnProperty("Appointment date") || !validHeader.hasOwnProperty("Weight")) {
            this.flipkartprogress = false;
            this.$alert('Please select correct file format', "", "error");
        } else if (this.clientFileType == 1 &&
          (!validHeader.hasOwnProperty("Seller ID") || !validHeader.hasOwnProperty("Pickup location") ||
            !validHeader.hasOwnProperty("City") || !validHeader.hasOwnProperty("Pin code") ||
            !validHeader.hasOwnProperty("Contact person") || !validHeader.hasOwnProperty("Phone Number") ||
            !validHeader.hasOwnProperty("Delivery FC Location") || !validHeader.hasOwnProperty("PRQ number") ||
            !validHeader.hasOwnProperty("CN") || !validHeader.hasOwnProperty("Status"))) {
              this.flipkartprogress = false;
            this.$alert('Please select correct file format', "", "error");
        } else if (this.clientFileType == 0 &&
          (!validHeader.hasOwnProperty("Seller Address") || !validHeader.hasOwnProperty("Seller City") ||
            !validHeader.hasOwnProperty("Seller Pincode") || !validHeader.hasOwnProperty("Seller Mobile") ||
            !validHeader.hasOwnProperty("Seller GSTIN") || !validHeader.hasOwnProperty("Consignee Name") ||
            !validHeader.hasOwnProperty("Delivery Address") || !validHeader.hasOwnProperty("Destination City") ||
            !validHeader.hasOwnProperty("Destination Pin Code") || !validHeader.hasOwnProperty("Contact person Cnee") ||
            !validHeader.hasOwnProperty("Phone Number Cnee") || !validHeader.hasOwnProperty("Cnee Email id") ||
            !validHeader.hasOwnProperty("Consignee GSTIN"))) {
              this.flipkartprogress = false;
              this.$alert('Please select correct file format', "", "error");
        } else {
          this.bookingDataArr = [];
          this.vaidData =[];
          this.flipkartUpload = true;
          this.validFCPO=[];
          this.totalPackage = 0;
          let polistcount = {}
          for (var key in bookingData) {
            if (bookingData[key]["PO Numbers"] ) {
              polistcount[bookingData[key]["PO Numbers"]] = polistcount[bookingData[key]["PO Numbers"]] ? polistcount[bookingData[key]["PO Numbers"]] + 1 : 1;
            }
          }
          for (var key in bookingData) {
            if (bookingData[key]["Seller Name"] || bookingData[key]["Seller Email id"] || bookingData[key]["Category"] ||
              bookingData[key]["Number of packages"]) {
              let sellerid; let pickuplocation; let status;
              let cn; let prqnumber; let sellerpincode; let sellercity;
              let sellerpoc; let sellermobile; let consigneename;
              let consigneeaddress; let consigneecity; let consigneespoc;
              let consigneemobile; let consigneeemail; let sellergstin;
              let consigneegstin; let consigneepincode;
              let isvalid = 1;
              let comment = "";
              let mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
              let gstformat = /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}Z[0-9a-zA-Z]{1}$/;
              let mobileformat = /^(0|[+91]{3})?[6789]\d{9}$/;

              if (this.clientFileType == 1) {
                sellerid = bookingData[key]["Seller ID"];
                pickuplocation = bookingData[key]["Pickup location"];
                sellerpincode = bookingData[key]["Pin code"];
                sellercity = bookingData[key]["City"];
                consigneespoc = bookingData[key]["Contact person"];
                consigneemobile = bookingData[key]["Phone Number"];
                consigneename = bookingData[key]["Delivery FC Location"];
                status = bookingData[key]["Status"];
                cn = bookingData[key]["CN"];
                prqnumber = bookingData[key]["PRQ number"];
              }

              if (this.clientFileType == 0) {
                sellerpincode = bookingData[key]["Seller Pincode"];
                pickuplocation = bookingData[key]["Seller Address"];
                sellercity = bookingData[key]["Seller City"];
                sellermobile = bookingData[key]["Seller Mobile"];
                consigneename = bookingData[key]["Consignee Name"];
                consigneeaddress = bookingData[key]["Delivery Address"];
                consigneecity = bookingData[key]["Destination City"];
                consigneepincode = bookingData[key]["Destination Pin Code"];
                sellergstin = bookingData[key]["Seller GSTIN"];
                consigneegstin = bookingData[key]["Consignee GSTIN"];
                consigneespoc = bookingData[key]["Contact person Cnee"];
                consigneemobile = bookingData[key]["Phone Number Cnee"];
                consigneeemail = bookingData[key]["Cnee Email id"];
              }

              //Check for mandatory fields
              let mandatoryFieldArr = [];
              if (bookingData[key]["Seller Name"] == null || bookingData[key]["Seller Name"] == "") {
                mandatoryFieldArr.push('Seller Name');
              }
              if (bookingData[key]["Seller Email id"] == null || bookingData[key]["Seller Email id"] == "") {
                mandatoryFieldArr.push('Seller Email id');
              }
              if (bookingData[key]["Volume Details"] == null || bookingData[key]["Volume Details"] == "") {
                mandatoryFieldArr.push('Volume Details');
              }
              if ((bookingData[key]["Weight"] == null || bookingData[key]["Weight"] == "") || isNaN(bookingData[key]["Weight"] == "")) {
                mandatoryFieldArr.push('Weight');
              }
              if ((bookingData[key]["Number of packages"] == null || bookingData[key]["Number of packages"] == "") || !this.isNumeric(bookingData[key]["Number of packages"])) {
                mandatoryFieldArr.push('Number of packages');
              }
              if ((bookingData[key]["Qty"] == null || bookingData[key]["Qty"] == "") || !this.isNumeric(bookingData[key]["Qty"])) {
                mandatoryFieldArr.push('Qty');
              }
              if (bookingData[key]["Pickup date"] == null || bookingData[key]["Pickup date"] == "") {
                mandatoryFieldArr.push('Pickup date');
              }
              if (bookingData[key]["Pickup Slot"] == null || bookingData[key]["Pickup Slot"] == "") {
                mandatoryFieldArr.push('Pickup Slot');
              }
              if (bookingData[key]["PO Numbers"] == null || bookingData[key]["PO Numbers"] == "") {
                mandatoryFieldArr.push('PO Numbers');
              } else if (polistcount[bookingData[key]["PO Numbers"]] > 1) {
                mandatoryFieldArr.push('Multiple times PO Number Present');
              }
              if ((bookingData[key]["Invoice value"] == null || bookingData[key]["Invoice value"] == "")) {
                mandatoryFieldArr.push('Invoice value(Must be Numeric)');
              }

              if (this.clientFileType == 1) {
                if (bookingData[key]["Seller ID"] == null || bookingData[key]["Seller ID"] == "") {
                  mandatoryFieldArr.push('Seller ID');
                }
                if (bookingData[key]["Pickup location"] == null || bookingData[key]["Pickup location"] == "") {
                  mandatoryFieldArr.push('Pickup location');
                }
                if (bookingData[key]["Pin code"] == null || bookingData[key]["Pin code"] == "") {
                  mandatoryFieldArr.push('Pin code');
                }
                if (bookingData[key]["City"] == null || bookingData[key]["City"] == "") {
                  mandatoryFieldArr.push('City');
                }
                if (bookingData[key]["Contact person"] == null || bookingData[key]["Contact person"] == "") {
                  mandatoryFieldArr.push('Contact person');
                }
                if (bookingData[key]["Phone Number"] == null || bookingData[key]["Phone Number"] == "") {
                  mandatoryFieldArr.push('Phone Number');
                }
                if (bookingData[key]["Delivery FC Location"] == null || bookingData[key]["Delivery FC Location"] == "") {
                  mandatoryFieldArr.push('Delivery FC Location');
                }
              }
              if (this.clientFileType == 0) {

                if (bookingData[key]["Seller Pincode"] == null || bookingData[key]["Seller Pincode"] == "") {
                  mandatoryFieldArr.push('Seller Pincode');
                }
                if (bookingData[key]["Seller Address"] == null || bookingData[key]["Seller Address"] == "") {
                  mandatoryFieldArr.push('Seller Address');
                }
                if (bookingData[key]["Seller City"] == null || bookingData[key]["Seller City"] == "") {
                  mandatoryFieldArr.push('Seller City');
                }
                if (bookingData[key]["Seller Mobile"] == null || bookingData[key]["Seller Mobile"] == "") {
                  mandatoryFieldArr.push('Seller Mobile');
                }
                if (bookingData[key]["Consignee Name"] == null || bookingData[key]["Consignee Name"] == "") {
                  mandatoryFieldArr.push('Consignee Name');
                }
                if (bookingData[key]["Delivery Address"] == null || bookingData[key]["Delivery Address"] == "") {
                  mandatoryFieldArr.push('Delivery Address');
                }
                if (bookingData[key]["Destination City"] == null || bookingData[key]["Destination City"] == "") {
                  mandatoryFieldArr.push('Destination City');
                }
                if (bookingData[key]["Destination Pin Code"] == null || bookingData[key]["Destination Pin Code"] == "") {
                  mandatoryFieldArr.push('Destination Pin Code');
                }
                if (bookingData[key]["Seller GSTIN"] == null || bookingData[key]["Seller GSTIN"] == "") {
                  mandatoryFieldArr.push('Seller GSTIN');
                }
                if (bookingData[key]["Consignee GSTIN"] == null || bookingData[key]["Consignee GSTIN"] == "") {
                  mandatoryFieldArr.push('Consignee GSTIN');
                }
                if (bookingData[key]["Contact person Cnee"] == null || bookingData[key]["Contact person Cnee"] == "") {
                  mandatoryFieldArr.push('Contact person Cnee');
                }
                if (bookingData[key]["Phone Number Cnee"] == null || bookingData[key]["Phone Number Cnee"] == "") {
                  mandatoryFieldArr.push('Phone Number Cnee');
                }
                if (bookingData[key]["Cnee Email id"] == null || bookingData[key]["Cnee Email id"] == "") {
                  mandatoryFieldArr.push('Cnee Email id');
                }
              }
              if (moment(bookingData[key]["Pickup date"], 'D/M/YYYY', true).isValid()) {
                bookingData[key]["Pickup date"] = moment(bookingData[key]["Pickup date"], 'D/M/YYYY').format('DD/MM/YYYY')
              }
              if (bookingData[key]["Appointment date"] && moment(bookingData[key]["Appointment date"], 'D/M/YYYY', true).isValid()) {
                  bookingData[key]["Appointment date"] = moment(bookingData[key]["Appointment date"], 'D/M/YYYY').format('DD/MM/YYYY')
              }
              if (mandatoryFieldArr.length > 0) {
                comment = "Invalid Record : Mandatory Fields Missing : " + mandatoryFieldArr.join(", ");
                isvalid = 0;
              }else if (bookingData[key]["Category"] && bookingData[key]["Category"] != null && bookingData[key]["Category"].length>255) {
                comment = "Invalid Record : Invalid Category. Max length is 255.";
                isvalid = 0;
              }else if (bookingData[key]["PO Numbers"] && bookingData[key]["PO Numbers"].length >200) {
                comment = "Invalid Record : Invalid PO Numbers. Max length is 200.";
                isvalid = 0;
              }else if (parseFloat(bookingData[key]["Invoice value"]) < 1) {
                comment = "Invalid Record : Invoice Value Should not be less than 1.";
                isvalid = 0;
              } else if (parseFloat(bookingData[key]["Weight"]) <= 0) {
                comment = "Invalid Record : Weight Should be greater than 0.";
                isvalid = 0;
              } else if (!bookingData[key]["Seller Email id"].match(mailformat)) {
                comment = "Invalid Record : Invalid Seller Email id.";
                isvalid = 0;
              } else if (bookingData[key]["Seller Email id"] && bookingData[key]["Seller Email id"].length>100) {
                comment = "Invalid Record : Invalid Seller Email id. Max length is 100";
                isvalid = 0;
              }else if (consigneeemail != null && !consigneeemail.match(mailformat)) {
                comment = "Invalid Record : Invalid Consignee Email id.";
                isvalid = 0;
              } else if (consigneeemail != null && consigneeemail.length>100) {
                comment = "Invalid Record : Invalid Consignee Email id. Max length is 100.";
                isvalid = 0;
              }else if (consigneeaddress != null && consigneeaddress.length>255) {
                comment = "Invalid Record : Invalid Consignee Address. Max length is 255.";
                isvalid = 0;
              }else if (sellermobile != null && !mobileformat.test(sellermobile)) {
                comment = "Invalid Record : Invalid Seller Contact Number.";
                isvalid = 0;
              }else if (bookingData[key]["Seller Name"] && bookingData[key]["Seller Name"].length >100) {
                comment = "Invalid Record : Invalid Seller Name. Max length is 100.";
                isvalid = 0;
              }else if (bookingData[key]["Consignee Name"] && bookingData[key]["Consignee Name"].length >200) {
                comment = "Invalid Record : Invalid Consignee Name. Max length is 200.";
                isvalid = 0;
              }else if (bookingData[key]["Pickup location"] && bookingData[key]["Pickup location"].length >255) {
                comment = "Invalid Record : Invalid Pickup location. Max length is 255.";
                isvalid = 0;
              }else if (bookingData[key]["Seller Address"] && bookingData[key]["Seller Address"].length >255) {
                comment = "Invalid Record : Invalid Seller Address. Max length is 255.";
                isvalid = 0;
              }else if (bookingData[key]["Delivery Address"] && bookingData[key]["Delivery Address"].length >255) {
                comment = "Invalid Record : Invalid Delivery Address. Max length is 255.";
                isvalid = 0;
              }else if (bookingData[key]["Contact person"] && bookingData[key]["Contact person"].length >200) {
                comment = "Invalid Record : Invalid Contact person. Max length is 200.";
                isvalid = 0;
              }else if (bookingData[key]["Contact person Cnee"] && bookingData[key]["Contact person Cnee"].length >200) {
                comment = "Invalid Record : Invalid Contact person Cnee. Max length is 200.";
                isvalid = 0;
              }else if (bookingData[key]["PO Numbers"] && bookingData[key]["PO Numbers"].length >200) {
                comment = "Invalid Record : Invalid PO Numbers. Max length is 200.";
                isvalid = 0;
              }else if (parseInt(bookingData[key]["Number of packages"]) < 1) {
                comment = "Invalid Record : Invalid Number of packages.";
                isvalid = 0;
              } else if (consigneemobile != null && !mobileformat.test(consigneemobile)) {
                comment = "Invalid Record : Invalid Phone Number Consignee.";
                isvalid = 0;
              } else if (!moment(bookingData[key]["Pickup date"], 'DD/MM/YYYY', true).isValid()) {
                comment = "Invalid Record : Invalid Pickup Date. Valid Format : DD/MM/YYYY";
                isvalid = 0;
              } else if (bookingData[key]["Appointment date"] && !moment(bookingData[key]["Appointment date"], 'DD/MM/YYYY', true).isValid()) {
                comment = "Invalid Record : Invalid Appointment Date. Valid Format : DD/MM/YYYY";
                isvalid = 0;
              } else if (sellerpincode != null && (sellerpincode.toString().length != 6 || isNaN(sellerpincode))) {
                comment = "Invalid Record : Invalid Seller Pincode.";
                isvalid = 0;
              } else if (consigneepincode != null && (consigneepincode.toString().length != 6 || isNaN(consigneepincode))) {
                comment = "Invalid Record : Invalid Destination Pincode.";
                isvalid = 0;
              } else if (isNaN(bookingData[key]["Invoice value"])) {
                comment = "Invalid Record : Invoice Value must be nummeric";
                isvalid = 0;
              } else {
                let pickuptime = bookingData[key]["Pickup Slot"].split("*");
                let dimensions = bookingData[key]["Volume Details"].split("*");

                let pickupdate = moment(bookingData[key]["Pickup date"], 'D/M/YYYY').format('YYYY-MM-DD');
                let appointmentdate;
                if (bookingData[key]["Appointment date"]) {
                  appointmentdate = moment(bookingData[key]["Appointment date"], 'D/M/YYYY').format('YYYY-MM-DD');
                }
                let newslot = pickuptime[0] + ':' + pickuptime[1];
                let temppickupdate = moment(bookingData[key]["Pickup date"] + ' ' + newslot, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm');
                if (pickuptime.length != 2 || pickuptime[0] > 24 || pickuptime[1] > 60 || !Number.isInteger(Number(pickuptime[0])) || !Number.isInteger(Number(pickuptime[1])) || (pickuptime[0].indexOf('.')!= -1) || (pickuptime[1].indexOf('.')!= -1) || (pickuptime[0].indexOf('-')!= -1) || (pickuptime[1].indexOf('-')!= -1)) {
                  comment = "Invalid Record : Invalid Pickup Slot.";
                  isvalid = 0;
                } else if (dimensions.length != 3) {
                  comment = "Invalid Record : Invalid Volume Details";
                  isvalid = 0;
                }
                 else if(temppickupdate < moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')){
                   comment = "Invalid Record : Pickup date time should be greater than current date time.";
                   isvalid = 0;
                 }
                else if (bookingData[key]["Appointment date"] && (appointmentdate < pickupdate)) {
                  comment = "Invalid Record : Appointment date should be greater than Pickup date.";
                  isvalid = 0;
                } else if (consigneegstin != null && !consigneegstin.match(gstformat) && consigneegstin.toLowerCase() != 'urp' && consigneegstin.toLowerCase() == '00xxxxx0000x1zz') {
                  comment = "Invalid Record : Invalid Consignee GST format";
                  isvalid = 0;
                } else if (sellergstin != null && !sellergstin.match(gstformat) && sellergstin.toLowerCase() != 'urp' && sellergstin.toLowerCase() == '00xxxxx0000x1zz' ) {
                  comment = "Invalid Record : Invalid Seller GST format";
                  isvalid = 0;
                } else {
                  comment = "Valid Record.";
                  isvalid = 1;
                }
              }

              let payloadData = {
                sellerid: sellerid,
                sellername: bookingData[key]["Seller Name"],
                selleraddress: pickuplocation,
                sellercity: sellercity,
                sellerpincode: sellerpincode,
                sellerpoc: sellerpoc,
                sellermobile: sellermobile,
                selleremail: bookingData[key]["Seller Email id"],
                sellergstin: sellergstin,
                consigneename: consigneename,
                consigneeaddress: consigneeaddress,
                consigneecity: consigneecity,
                consigneepincode: consigneepincode,
                consigneespoc: consigneespoc,
                consigneemobile: consigneemobile,
                consigneeemail: consigneeemail,
                consigneegstin: consigneegstin,
                category: bookingData[key]["Category"],
                volumedetails: bookingData[key]["Volume Details"],
                weight: bookingData[key]["Weight"] && isvalid ? parseFloat(bookingData[key]["Weight"]) : null,
                noofpackages: bookingData[key]["Number of packages"] ? bookingData[key]["Number of packages"] : null,
                quantity: (bookingData[key]["Qty"]) && isvalid ? bookingData[key]["Qty"] : null,
                pickupdate: bookingData[key]["Pickup date"],
                pickupslot: bookingData[key]["Pickup Slot"],
                appointmentdate: (bookingData[key]["Appointment date"]) ? bookingData[key]["Appointment date"] : null,
                ponumber: bookingData[key]["PO Numbers"] ? bookingData[key]["PO Numbers"] : null,
                invoicevalue: bookingData[key]["Invoice value"] && isvalid ? bookingData[key]["Invoice value"] : null,
                prqnumber: prqnumber,
                cn: cn,
                comment: comment,
                isvalid: isvalid,
              }
              this.bookingDataArr.push(payloadData);
              if (isvalid) {
                this.totalPackage = this.totalPackage + Number(bookingData[key]["Number of packages"]);
                if(bookingData[key]["PO Numbers"]) {
                  this.validFCPO.push(bookingData[key]["PO Numbers"]);
                }
                this.vaidData.push(bookingData)
              }
            }
          }
          if (this.validFCPO.length == 0) {
            this.disabled = true;
          }
          let logcount = this.groupBy(this.bookingDataArr, "isvalid");
          if (logcount[1]) {
            this.successRecords = logcount[1];
            this.validrecordsforimport = logcount[1].length;
          }
          if (logcount[0]) {
            this.failedRecords = logcount[0];
            this.FCfaileddata = logcount[0]
            this.failRecordCount = logcount[0].length;
            // this.$alert('The upload data is incorrect. Please validate data to upload.', "", "error");

          }
          this.showresult = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async validatetmpldata(bookingData) {
      try {
        let validHeader = bookingData[0];
        if (!validHeader.hasOwnProperty("Consignor")  || !validHeader.hasOwnProperty("PickupPinCode")  || !validHeader.hasOwnProperty("LRNo") ||
          !validHeader.hasOwnProperty("Consignee") || !validHeader.hasOwnProperty("Location") ||
          !validHeader.hasOwnProperty("PinCode") || !validHeader.hasOwnProperty("State") ||
          !validHeader.hasOwnProperty("Material") || !validHeader.hasOwnProperty("Shipment") ||
          !validHeader.hasOwnProperty("Description") || !validHeader.hasOwnProperty("Qty") ||
          !validHeader.hasOwnProperty("InvoiceDate") || !validHeader.hasOwnProperty("ActualWeight") ||
          !validHeader.hasOwnProperty("ChargedWeight") || !validHeader.hasOwnProperty("InvoiceValue")
         ) {
            this.flipkartprogress = false;
            this.$alert('Please select correct file format', "", "error");
        } else {
          this.validFCPO=[];
          this.bookingData = [];
          this.flipkartUpload = true;
          let tempArr1 = [];
          for (var key in bookingData) {
            let payloadData = {
              consignor: bookingData[key]["Consignor"],
              pickuppincode: bookingData[key]["PickupPinCode"],
              consignee: bookingData[key]["Consignee"],
              location: bookingData[key]["Location"],
              pincode: bookingData[key]["PinCode"],
              state: bookingData[key]["State"],
              material: bookingData[key]["Material"],
              shipment: bookingData[key]["Shipment"],
              description: bookingData[key]["Description"],
              qty: bookingData[key]["Qty"],
              invoicedate: bookingData[key]["InvoiceDate"],
              actualweight: bookingData[key]["ActualWeight"],
              chargedweight: bookingData[key]["ChargedWeight"],
              invoicevalue: bookingData[key]["InvoiceValue"]
            }
            tempArr1.push(payloadData);
          }
          let bookingDataArr = tempArr1.filter(obj => {
              return Object.keys(obj).some(key => obj[key].trim() !== "");
          });

          let validBookingDataArr = [];
          for (var key in bookingDataArr) {
            let payloadData = bookingDataArr[key];
            let isvalid = 1;
            let comment = "";
            let mandatoryFieldArr = [];
            if (bookingDataArr[key]["consignor"] == null || bookingDataArr[key]["consignor"] == "") {
              mandatoryFieldArr.push('Consignor');
            }
            if ((bookingDataArr[key]["pickuppincode"] == null || bookingDataArr[key]["pickuppincode"] == "") || isNaN(bookingDataArr[key]["pickuppincode"] == "")) {
              mandatoryFieldArr.push('PickupPinCode');
            }
            if (bookingDataArr[key]["consignee"] == null || bookingDataArr[key]["consignee"] == "") {
              mandatoryFieldArr.push('Consignee');
            }
            if ((bookingDataArr[key]["pincode"] == null || bookingDataArr[key]["pincode"] == "") || isNaN(bookingDataArr[key]["pincode"] == "")) {
              mandatoryFieldArr.push('PinCode');
            }
            if (bookingDataArr[key]["shipment"] == null || bookingDataArr[key]["shipment"] == "") {
              mandatoryFieldArr.push('Shipment');
            }
            if (bookingDataArr[key]["description"] == null || bookingDataArr[key]["description"] == "") {
              mandatoryFieldArr.push('Description');
            }
            if (mandatoryFieldArr.length > 0) {
              comment = "Invalid Record : Mandatory Fields Missing : " + mandatoryFieldArr.join(", ");
              isvalid = 0;
            }else if (bookingDataArr[key]["actualweight"] && isNaN(bookingDataArr[key]["actualweight"])) {
              comment = "Invalid Record : Actual Weight value should be numeric.";
              isvalid = 0;
            }else if (bookingDataArr[key]["chargedweight"] && isNaN(bookingDataArr[key]["chargedweight"])) {
              comment = "Invalid Record : Charged Weight value should be numeric";
              isvalid = 0;
            }else if (bookingDataArr[key]["invoicevalue"] && isNaN(bookingDataArr[key]["invoicevalue"])) {
              comment = "Invalid Record : Invoice value should be numeric";
              isvalid = 0;
            }else{
              comment = "Valid Record";
              isvalid = 1;
            }
            payloadData.numberofmps = 1;
            payloadData.comment = comment;
            payloadData.isvalid = isvalid;
            validBookingDataArr.push(payloadData);
          }
          this.bookingDataArray = validBookingDataArr;
          let logcount = this.groupBy(this.bookingDataArray, "isvalid");
          this.totalRecords = validBookingDataArr.length;
          if (logcount[1]) {
            this.successRecords = logcount[1];
            this.validrecordsforimport = logcount[1].length;
            this.validFCPO = logcount[1];
          }
          if (logcount[0]) {
            this.failedRecords = logcount[0];
            this.FCfaileddata = logcount[0]
            this.failRecordCount = logcount[0].length;
          }
          this.showresult = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    isNumeric(value) {
      return /^\d+$/.test(value);
    },
    groupByMultipleAttribute(array, keys){
      return array.reduce((result, currentValue) => {
        // Create a unique key by combining the values of the specified keys
        const combinedKey = keys.map(key => currentValue[key]).join('-');
        // Initialize the array if it doesn't exist
        if (!result[combinedKey]) {
          result[combinedKey] = [];
        }
        // Push the current value to the array
        result[combinedKey].push(currentValue);
        return result;
      }, {});
    },
    async resumealidation() {
      try {
        this.FCResumeValidation= false;
        this.importValidRecords()
      } catch (error) {
        console.log(error);
      }
    },
    scrollToProgress(){
      window.scrollTo({ top: 200, behavior: "smooth" });
    },
    async validateflikartUploadeddata(totalrecord) {
      try {
        let loop = Math.ceil(totalrecord / this.batchsizeforimport)
        let offset = 0
        let InputPayload = {
          clientfiletype: this.clientFileType,
          clientid: this.client.ClientId,
          clientname: this.client.label,
          clientbusinessdetailid: this.clientbusinessdetailid,
          clientbusinessaccountid: this.clientbusinessaccountid,
          businessaccountname: this.businessaccountname,
          fileid: this.logfileid,
          limit: this.batchsizeforimport,
          offset: offset,
          lastmodifiedby: this.userName,
        }
        let uploadata;
        for (let i = 0; i < loop ; i++) {

          let result = await BookingService.ValidateFCData(InputPayload)
          if (result.data.code == 200) {
            uploadata = result.data.data;
          } else {

          }
          InputPayload.offset = InputPayload.offset+this.batchsizeforimport
          this.flipkartDataValiated = InputPayload.offset
        }
        this.flipkartDataValiated = totalrecord;
        this.showSpinner = false;
        this.totalRecords = uploadata.length + this.FCfaileddata.length;
        let logcount = this.groupBy(uploadata, "isvalid");
        if(logcount[1]){
          this.successRecords = logcount[1];
          this.validrecordsforimport = logcount[1].length;
          this.showimportbutton = true;
        }
        if(logcount[0]){
          this.failedRecords = logcount[0];
          if(this.FCfaileddata.length > 0) {
            this.failedRecords.push(...this.FCfaileddata)
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async validatetmplUploadeddata(totalrecord) {
      try {
        this.failedRecords = [];
        this.FCfaileddata = [];
        let loop = Math.ceil(totalrecord / this.batchsizeforimport)
        let offset = 0
        let InputPayload = {
          clientid: this.client.ClientId,
          clientname: this.client.label,
          clientbusinessdetailid: this.clientbusinessdetailid,
          clientbusinessaccountid: this.clientbusinessaccountid,
          businessaccountname: this.businessaccountname,
          fileid: this.logfileid,
          limit: this.batchsizeforimport,
          offset: offset,
          lastmodifiedby: this.userName,
        }
        let uploadata;
        for (let i = 0; i < loop ; i++) {
          let result = await BookingService.ValidateTMPLData(InputPayload);
          if (result.data.code == 200) {
            let jsonArray = result.data.data;
            totalrecord = result.data.data.length;
            jsonArray.forEach(obj => {
                // Rename the attribute
                obj.consignor = obj.pickuplocationname;
                obj.pincode = obj.destinationpincode;
                obj.consignee = obj.consingneecode;
                delete obj.pickuplocationname;
                delete obj.destinationpincode;
                delete obj.consingneecode;
            });
            uploadata = jsonArray;
          } else {
          }
          InputPayload.offset = InputPayload.offset+this.batchsizeforimport
          this.flipkartDataValiated = InputPayload.offset
        }
        this.flipkartDataValiated = totalrecord;
        this.showSpinner = false;
        this.totalRecords = uploadata.length;
        let logcount = this.groupBy(uploadata, "status");
        if(logcount[1]){
          this.successRecords = logcount[1];
          this.validrecordsforimport = logcount[1].length;
          this.showimportbutton = true;
        }
        if(logcount[0]){
          this.failedRecords = logcount[0];
          if(this.FCfaileddata.length > 0) {
            this.failedRecords.push(...this.FCfaileddata)
          }else{
            this.failedRecords = logcount[0];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ValidateGenericClientData(totalrecord) {
      try {
        let loop = Math.ceil(totalrecord / this.batchsizeforimport)
        let offset = 0
        let InputPayload = {
          fileid: this.logfileid,
          limit: this.batchsizeforimport,
          offset: offset,
          lastmodifiedby: this.userName,
        }
        let uploadata;
        for (let i = 0; i < loop ; i++) {
          let result = await BookingService.ValidateGenericClientData(InputPayload)
          if (result.data.code == 200) {
            uploadata = result.data.data;
          } else {

          }
          InputPayload.offset = InputPayload.offset+this.batchsizeforimport
          this.flipkartDataValiated = InputPayload.offset
        }
        this.flipkartDataValiated = totalrecord;
        this.showSpinner = false;
        this.totalRecords = uploadata.length + this.GenericFilefaileddata.length;
        let logcount = this.groupBy(uploadata, "status");
        if(logcount[1]){
          this.successRecords = logcount[1];
          this.validrecordsforimport = logcount[1].length;
          this.showimportbutton = true;
        }
        if(logcount[0]){
          this.failedRecords = logcount[0];
          if(this.GenericFilefaileddata.length > 0) {
            this.failedRecords.push(...this.GenericFilefaileddata)
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/dataUpload/dataUpload.component.js